var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg29(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "282.73mm",
    height: "130.02mm",
    viewBox: "0 0 282.73 130.02",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath17881"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.4305e-5 0h960v540h-960z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath17893"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.4305e-5 0h960v540h-960z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath17933"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-3.0518e-5 540h960v-540l-960-6.1035e-5",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath17943"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-3.0518e-5 540h960v-540l-960-6.1035e-5",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath17953"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-6.1035e-5 540h960v-540l-960-6.104e-5",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath17963"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-6.1035e-5 540h960v-540l-960-6.104e-5",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath17981"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m155.25 215.25h99v99h-99z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath17991"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h72.75v72.75h-72.75z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath18011"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m576.75 80.25h87v87h-87z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath18021"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h72.75v72.75h-72.75z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath18031"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m435.75 154.5h72v72h-72z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath18041"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h72.75v72.75h-72.75z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath18051"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m256.14 242.44 69.97-16.94-16.94-69.98-69.98 16.95z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath18061"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h72.75v72.75h-72.75z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath18071"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m227.41 241.28 35.45-62.66-62.66-35.46-35.46 62.67z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath18081"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h72.75v72.75h-72.75z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath18091"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m476.25 231h199.5v199.5h-199.5z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath18101"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h72.75v72.75h-72.75z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath18157"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m810.75 265.5h72v72h-72z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath18167"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h72.75v72.75h-72.75z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath18177"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m671.25 261h72v72h-72z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath18187"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h72.75v72.75h-72.75z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath18197"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m676.5 341.25h72v72h-72z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath18207"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h72.75v72.75h-72.75z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath18225"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m797.25 335.25h72v72h-72z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath18235"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h72.75v72.75h-72.75z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath18247"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m501.75 80.25h87v87h-87z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath18257"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h72.75v72.75h-72.75z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath18271"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m369 217.5h72v72h-72z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath18281"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h72.75v72.75h-72.75z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath18291"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m328.5 150.75h72v72h-72z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath18301"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h72.75v72.75h-72.75z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-559.4 -411.15)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.35278 0 0 -.35278 519.34 565.36)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m113.57 68.571h801.43v368.57h-801.43z",
    fill: "#ffffff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath17881)"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1,0,0,-1,7.2,485.4)",
    fill: "#000000",
    fontFamily: "TimesNewRomanPSMT",
    fontSize: "36.05px"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: "0 20.224051 36.01395 45.026451 54.038952 65.286552 93.045052 108.83495 120.8396 136.6295 153.89745 169.68735 186.95531 204.9803 213.9928 228.23254 244.02245 256.0271 271.81699 281.58655 291.32004 307.10995 316.12244 334.14746 349.93735 367.96234 383.75226 395.7569 405.5625 433.32101 449.1109 466.37885 476.14841 487.396 501.63574 511.4053 528.67328 540.67792",
    y: 0
  }, "Sell merchandise at a department store"))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath17893)"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1,0,0,-1,573.9,485.4)",
    fill: "#000000",
    fontFamily: "TimesNewRomanPSMT",
    fontSize: "36.05px"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: "0 12.00465 33.778851",
    y: 0
  }, "(E)"))), /*#__PURE__*/React.createElement("path", {
    d: "m265.88 265.87c0 27.76 22.66 50.25 50.62 50.25s50.63-22.49 50.63-50.25c0-27.75-22.67-50.25-50.63-50.25s-50.62 22.5-50.62 50.25z",
    fill: "#000000",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m265.88 265.87c0 27.76 22.66 50.25 50.62 50.25s50.63-22.49 50.63-50.25c0-27.75-22.67-50.25-50.63-50.25s-50.62 22.5-50.62 50.25z",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "m294.38 193.12h17.25v44.25h-17.25z",
    fill: "#000000",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m294.38 193.12h17.25v44.25h-17.25z",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "m313.88 191.62h17.25v44.25h-17.25z",
    fill: "#000000",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m313.88 191.62h17.25v44.25h-17.25z",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "m288.38 276c0 8.91 7.55 16.12 16.87 16.12s16.88-7.21 16.88-16.12-7.56-16.13-16.88-16.13-16.87 7.22-16.87 16.13z",
    fill: "#ffffff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m288.38 276c0 8.91 7.55 16.12 16.87 16.12s16.88-7.21 16.88-16.12-7.56-16.13-16.88-16.13-16.87 7.22-16.87 16.13z",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "m311.63 276c0 8.91 7.55 16.12 16.87 16.12s16.88-7.21 16.88-16.12-7.56-16.13-16.88-16.13-16.87 7.22-16.87 16.13z",
    fill: "#ffffff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m311.63 276c0 8.91 7.55 16.12 16.87 16.12s16.88-7.21 16.88-16.12-7.56-16.13-16.88-16.13-16.87 7.22-16.87 16.13z",
    fill: "none",
    stroke: "#ffffff",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m308.23 274.11c0-1.08-0.87-1.95-1.94-1.95-1.08 0-1.95 0.87-1.95 1.95 0 1.07 0.87 1.95 1.95 1.95 1.07 0 1.94-0.88 1.94-1.95z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m327.17 274.31c0-1.08-0.87-1.95-1.95-1.95s-1.95 0.87-1.95 1.95c0 1.07 0.87 1.95 1.95 1.95s1.95-0.88 1.95-1.95z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m288.38 307.87 25.5 49.5 25.5-49.5z",
    fill: "#4472c4"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m288.38 307.87 25.5 49.5 25.5-49.5z",
    fill: "none",
    stroke: "#2f528f",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath17933)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m277.1 246.58-11.87-7.69c-6.56-4.25-13.96-4.46-16.55-0.47-2.58 3.98 0.65 10.65 7.2 14.9l11.87 7.69z",
    fill: "#000000",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath17943)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m277.1 246.58-11.87-7.69c-6.56-4.25-13.96-4.46-16.55-0.47-2.58 3.98 0.65 10.65 7.2 14.9l11.87 7.69z",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath17953)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m361.25 271.64 17.36-9c9.59-4.96 15.17-13.22 12.46-18.45-2.71-5.22-12.67-5.43-22.26-0.46l-17.36 8.99z",
    fill: "#000000",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath17963)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m361.25 271.64 17.36-9c9.59-4.96 15.17-13.22 12.46-18.45-2.71-5.22-12.67-5.43-22.26-0.46l-17.36 8.99z",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    d: "m337.13 254.25c0-6.01-10.08-10.88-22.5-10.88-12.43 0-22.5 4.87-22.5 10.88h5.43c0-3 7.64-5.44 17.07-5.44 9.42 0 17.06 2.44 17.06 5.44z",
    fill: "#ffffff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m337.13 254.25c0-6.01-10.08-10.88-22.5-10.88-12.43 0-22.5 4.87-22.5 10.88h5.43c0-3 7.64-5.44 17.07-5.44 9.42 0 17.06 2.44 17.06 5.44z",
    fill: "none",
    stroke: "#a5a5a5",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "m125.63 149.62 19.31 77.25h362.62l19.32-77.25z",
    fill: "#ffffff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m125.63 149.62 19.31 77.25h362.62l19.32-77.25z",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath17981)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.375,-1.88e-7,-1.88e-7,1.375,155.25,215.25)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(.98969)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath17991)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m61.884 49.866c0 1.657-1.343 3-3 3h-25.5v11.25h-16.5v-11.25h-3c-1.657 0-3-1.343-3-3v-9l-4.5-10.5v-19.5h60v19.5l-4.5 10.5zm-43.5 12.75h13.5v-21h-13.5zm46.5-50.25h-57v11.25h57zm0 17.692v-4.942h-57v4.942l4.378 10.217 0.122 0.283v9.308c0 0.828 0.672 1.5 1.5 1.5h3v-11.25h16.5v11.25h25.5c0.828 0 1.5-0.672 1.5-1.5v-9.308l0.121-0.283z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.384 56.616h7.5v1.5h-7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.384 51.366h7.5v1.5h-7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.384 46.116h7.5v1.5h-7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m38.634 40.116h18.75v8.25h-18.75zm1.5 6.75h15.75v-5.25h-15.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m36.384 15.366c1.45 0 2.625 1.175 2.625 2.625s-1.175 2.625-2.625 2.625-2.625-1.175-2.625-2.625 1.175-2.625 2.625-2.625zm0 3.75c0.621 0 1.125-0.504 1.125-1.125s-0.504-1.125-1.125-1.125-1.125 0.504-1.125 1.125 0.504 1.125 1.125 1.125z"
  }))))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath18011)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.2083,0,-7.54e-7,1.2083,576.75,80.25)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(.98969)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath18021)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m52.444 45.366-12.348 12.348c-2.051 2.048-5.373 2.048-7.425 0l-12.348-12.348h-13.325l4.9788-29.867c0.296-1.811 1.864-3.138 3.699-3.133h41.416c1.835-5e-3 3.403 1.322 3.699 3.133l4.979 29.867zm-41.925-12h11.667l0.642-9h-10.809zm13.17 0h11.945v-9h-11.302zm26.139 10.5-0.642-9h-12.052v9zm-14.194-9h-12.052l-0.643 9h12.695zm0-12v-9h-10.552l-0.643 9zm1.5 0h11.194l-0.642-9h-10.552zm0 1.5v9h11.944l-0.642-9zm13.448 9h11.666l-1.5-9h-10.809zm0.107 1.5 0.643 9h12.666l-1.5-9zm-16.957 21.787c1.466 1.463 3.838 1.463 5.304 0l11.287-11.287h-27.879zm-12.296-12.787 0.642-9h-11.808l-1.5003 9zm-7.98-28.12-1.187 7.12h10.667l0.642-9h-7.902c-1.101-3e-3 -2.042 0.794-2.22 1.88zm45.856 0c-0.178-1.086-1.119-1.883-2.22-1.88h-7.903l0.643 9h10.667z",
    fill: "#000000"
  }))))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath18031)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(435.75,154.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(.98969)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath18041)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m56.634 52.924c-0.03 0.391-0.357 0.693-0.75 0.692h-6v5.325c-6e-3 5.341-4.334 9.669-9.675 9.675h-0.15c-1.888 1e-3 -3.735-0.554-5.31-1.596-0.427 0.061-0.858 0.093-1.29 0.096h-0.15c-5.341-6e-3 -9.669-4.334-9.675-9.675v-3.825h-6.75c-0.397 1e-3 -0.725-0.308-0.75-0.704l-3-48c-0.026-0.4134 0.289-0.7694 0.702-0.7951 0.016-1e-3 0.032-0.0014 0.048-0.0014h36c0.198 0.0019 0.387 0.0829 0.525 0.225l9 9c0.155 0.155 0.234 0.37 0.217 0.588zm-16.575 14.192h0.15c4.513-5e-3 8.17-3.662 8.175-8.175v-5.325h-5.25v3.825c-7e-3 4.015-2.491 7.61-6.245 9.035 1.003 0.424 2.081 0.641 3.17 0.64zm-4.934-1.672c3.789-0.794 6.504-4.132 6.509-8.003v-3.825h-9.75v5.325c2e-3 2.556 1.202 4.963 3.241 6.503zm-9.991-8.003c5e-3 4.415 3.514 8.029 7.927 8.162-1.717-1.792-2.677-4.179-2.677-6.662v-5.325h-5.25zm-10.452-51.825 2.906 46.5h6.046v-8.25c0-0.414 0.336-0.75 0.75-0.75s0.75 0.336 0.75 0.75v8.25h16.5v-8.25c0-0.414 0.336-0.75 0.75-0.75s0.75 0.336 0.75 0.75v8.25h8.952l-2.906-46.5zm36.075 1.2 2.831 45.3h1.601l2.921-37.964-7.34-7.336c-8e-3 -0.0105-0.013-0.0083-0.012 0z",
    fill: "#000000"
  }))))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath18051)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.97192 -.23532 .23532 .97192 239.19 172.47)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(.98969)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath18061)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m65.836 22.435-28.702 17.354v2.3c-0.024 1.645-1.097 3.089-2.664 3.588-2.509 0.834-4.171 3.218-4.086 5.86 0.23 3.119 2.71 5.599 5.829 5.829 3.312 0.094 6.074-2.514 6.169-5.827 1e-3 -0.057 2e-3 -0.115 2e-3 -0.173h1.5c2e-3 4.142-3.355 7.501-7.497 7.503-0.072 0-0.143-1e-3 -0.215-3e-3 -3.919-0.244-7.043-3.368-7.288-7.288-0.107-3.301 1.97-6.28 5.105-7.322 0.962-0.286 1.628-1.163 1.645-2.167v-2.3l-28.702-17.355c-2.1821-1.319-2.8815-4.158-1.5622-6.34 0.8363-1.383 2.3352-2.228 3.9517-2.228h54.126c2.55 0 4.617 2.068 4.617 4.618 0 1.616-0.845 3.114-2.228 3.951zm0.614-4.789c-0.358-1.359-1.595-2.299-3-2.28h-54.129c-1.7215 0-3.1172 1.395-3.1174 3.117-2e-4 1.091 0.5707 2.103 1.5049 2.668l28.676 17.339 28.676-17.339c1.214-0.71 1.787-2.156 1.39-3.505z",
    fill: "#000000"
  }))))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath18071)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.87036 .49241 -.49241 .87036 200.2 143.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(.98969)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath18081)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m56.259 60.141c0.225-0.075 0.375-0.225 0.525-0.375l10.875-10.65v-0.075l-9.975-7.575-3.75 3.525-1.275 1.125c-0.3 0.3-0.75 0.3-1.05 0-0.15-0.15-0.225-0.3-0.225-0.525v-36.675h-30v36.75c0 0.45-0.3 0.75-0.75 0.75-0.225 0-0.375-0.075-0.525-0.225l-1.275-1.2-3.75-3.525h-0.075l-9.9 7.575v0.075l10.875 10.65c0.15 0.15 0.3 0.225 0.525 0.3l10.2 3.825c2.55-2.625 6-4.125 9.675-4.125s7.125 1.5 9.675 4.125zm-10.2 5.325c-0.375 0-0.825-0.15-1.05-0.45-2.25-2.325-5.4-3.675-8.625-3.675s-6.375 1.35-8.625 3.675c-0.3 0.3-0.675 0.45-1.05 0.45-0.15 0-0.375 0-0.525-0.075l-10.2-3.825c-0.375-0.15-0.75-0.375-1.05-0.675l-10.95-10.725c-0.6-0.675-0.525-1.65 0.075-2.175l0.075-0.075 10.05-7.575c0.3-0.225 0.6-0.3 0.975-0.3s0.75 0.15 0.975 0.375l3.75 3.525v-36.525h33v36.45l3.75-3.525c0.525-0.525 1.35-0.525 1.95-0.075l10.05 7.65c0.675 0.525 0.75 1.575 0.225 2.175l-0.075 0.075-10.95 10.725c-0.3 0.3-0.675 0.525-1.05 0.675l-10.2 3.825c-0.15 0.075-0.525 0.075-0.525 0.075z",
    fill: "#000000"
  }))))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath18091)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.7708,-3.77e-7,-7.54e-7,2.7708,476.25,231)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(.98969)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath18101)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m44.053 42.189c-2.55 2.6-1.469 6.399 1.103 9.999 2.086 2.925 1.845 7.028 1.679 8.475-0.036 0.316-0.27 0.574-0.58 0.641l-4.285 0.96c-1.157 0.259-2.053 1.175-2.286 2.337l-0.276 1.943c-0.053 0.369-0.369 0.644-0.743 0.644h-0.019c0.179 0.355 0.274 0.747 0.276 1.145 0 1.439-1.167 2.606-2.606 2.606-1.438 0-2.605-1.167-2.605-2.606 2e-3 -0.396 0.095-0.787 0.273-1.142h-0.02c-0.373 0-0.689-0.275-0.742-0.644l-0.276-1.943c-0.233-1.163-1.129-2.08-2.286-2.339l-4.285-0.96c-0.311-0.068-0.544-0.325-0.581-0.641-0.165-1.445-0.407-5.55 1.68-8.475 2.572-3.6 3.652-7.399 1.102-9.999-2.457-2.508-3.441-6.78-3.509-11.925-5e-3 -0.34 0.224-0.638 0.554-0.72 3.282-0.793 6.638-1.245 10.013-1.348v-18.831h-3c-3.726-0.0041-6.746-3.0238-6.75-6.75v-0.75h1.5v0.75c3e-3 2.8981 2.352 5.2467 5.25 5.25h3v-6h1.5v6h3c2.898-0.0033 5.247-2.3519 5.25-5.25v-0.75h1.5v0.75c-4e-3 3.7262-3.024 6.7459-6.75 6.75h-3v18.832c3.329 0.115 6.638 0.567 9.875 1.35 0.33 0.082 0.559 0.38 0.554 0.72-0.068 5.141-1.054 9.414-3.51 11.921zm-7.737 27.252c0.611 0 1.106-0.495 1.106-1.106 0-0.61-0.495-1.105-1.106-1.105-0.61 0-1.105 0.495-1.105 1.105v1e-3c1e-3 0.61 0.496 1.104 1.105 1.105zm0-39.75c-3.276 0.042-6.54 0.434-9.733 1.17 0.139 4.886 1.171 8.342 3.067 10.275 2.821 2.878 2.483 7.111-0.952 11.925-1.582 2.214-1.575 5.396-1.46 6.9l3.75 0.841c1.736 0.389 3.08 1.764 3.429 3.508l8e-3 0.042 6e-3 0.041 0.187 1.298h3.396l0.185-1.298 6e-3 -0.042 8e-3 -0.042c0.349-1.744 1.693-3.119 3.429-3.508l3.75-0.841c0.112-1.5 0.122-4.683-1.46-6.9-3.435-4.81-3.774-9.043-0.953-11.925 1.897-1.936 2.928-5.392 3.068-10.275-3.193-0.735-6.455-1.127-9.731-1.169z",
    fill: "#000000"
  }))))), /*#__PURE__*/React.createElement("g", {
    fill: "#f2f2f2",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m637.21 338.16h133.74v71.504h-133.74z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m770.95 338.16h133.74v71.504h-133.74z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m637.21 266.65h133.74v71.504h-133.74z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m770.95 266.65h133.74v71.504h-133.74z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#ffffff",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "m770.95 410.16v-144.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m636.71 338.16h268.48",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m637.21 410.16v-144.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m904.69 410.16v-144.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m636.71 409.66h268.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m636.71 266.65h268.48"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath18157)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(810.75,265.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(.98969)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath18167)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m63.384 8.5987h-24.525c-0.773-0.0136-1.53 0.2191-2.162 0.6645-4.303 3.2248-6.917 8.1098-9.444 12.83-2.701 5.048-5.49 10.261-10.369 13.64v-27.134h-7.6328l0.144 0.8715c2.1048 12.782-0.0922 21.221-1.8577 28.002-1.0215 3.923-1.9035 7.311-1.9035 10.887 0 8.471 9.659 15.331 10.071 15.619l0.562 0.393 0.441-0.525c8.382-9.944 13.65-19.364 17.884-26.932 3.82-6.83 6.581-11.765 9.647-13.401 1.534-0.557 3.116-0.973 4.725-1.243 5.775-1.247 14.495-3.129 17.606-7.939 0.374-0.593 0.57-1.281 0.564-1.982-2e-3 -2.07-1.68-3.7478-3.75-3.7503zm-48 29.826 1.133-0.675c5.951-3.539 9.057-9.339 12.06-14.949 2.564-4.787 4.985-9.31 9.007-12.327 0.375-0.256 0.821-0.388 1.275-0.375h24.525c1.243 0 2.25 1.007 2.25 2.25 2e-3 0.409-0.11 0.81-0.324 1.158-2.78 4.299-11.138 6.102-16.668 7.296-1.746 0.283-3.457 0.748-5.105 1.388-3.459 1.844-6.309 6.94-10.254 13.994-4.125 7.374-9.239 16.518-17.267 26.154-2.015-1.567-8.882-7.388-8.882-13.98 0-3.384 0.8595-6.685 1.8555-10.509 1.7605-6.764 3.9415-15.144 2.0245-27.75h4.37z",
    fill: "#000000"
  }))))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath18177)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(671.25,261)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(.98969)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath18187)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m67.884 32.08c-0.071 0.932-1.239 3.165-3.437 3.165-0.102 0-0.207-4e-3 -0.313-0.015-0.961-0.103-1.926-0.156-2.892-0.156-4.557 0.049-9.028 1.238-13.008 3.457l-1.35 0.75c-1.444 0.829-2.846 1.73-4.2 2.7l-1.2 0.9c-1.35 0.975-2.625 1.95-3.975 2.925l-1.2 0.9c-2.125 1.57-4.384 2.95-6.75 4.125-0.213 0.093-0.443 0.141-0.675 0.141-0.813 0.015-1.485-0.632-1.5-1.445v-0.047-2.25c-3.533-1.446-7.31-2.201-11.128-2.223-3.146-0.026-6.2683 0.552-9.197 1.702-0.1726 0.069-0.3566 0.104-0.5423 0.104-0.6138 3e-3 -1.1691-0.364-1.4077-0.93-1.0415-2.944-1.6233-6.031-1.725-9.152v-15.004h17.25l1.5 3.75h3c3.3 0 7.05-0.825 10.65-1.65 2.4-0.525 4.875-1.05 7.125-1.35h0.3c2.508-0.373 5.039-0.574 7.575-0.6 4.95 0 10.875 0.975 18.6 4.8v2.175zm-61.394 13.241c3.1102-1.223 6.4263-1.837 9.7683-1.81 4.008 0.024 7.974 0.815 11.685 2.33l0.942 0.375v3.249c0 4e-3 3e-3 7e-3 7e-3 8e-3 1e-3 0 2e-3 0 2e-3 -1e-3 0.045-0.019 0.247-0.103 0.329-0.143 2.164-1.101 4.233-2.379 6.186-3.82l0.46-0.346-3.017-3.017c-0.298-0.288-0.306-0.762-0.018-1.06s0.762-0.306 1.06-0.019c7e-3 6e-3 0.013 0.013 0.019 0.019l3.172 3.172c0.51-0.372 1.016-0.744 1.517-1.117 0.662-0.491 1.323-0.983 1.983-1.458l0.459-0.345-2.192-2.192c-0.298-0.288-0.306-0.762-0.018-1.06s0.762-0.306 1.06-0.019c7e-3 6e-3 0.013 0.013 0.019 0.019l2.356 2.356c1.17-0.821 2.465-1.646 3.887-2.475l0.335-0.185-1.61-1.61c-0.308-0.3-0.315-0.792-0.015-1.1l0.015-0.015c0.296-0.268 0.751-0.257 1.033 0.026l1.955 1.958c4.107-2.235 8.7-3.426 13.376-3.467 1.013 1e-3 2.025 0.056 3.032 0.164 0.059 5e-3 0.117 8e-3 0.173 8e-3 1.275 0 1.909-1.481 1.942-1.78l0.021-0.272 0.114-0.246 0.201-0.431c-10.557-5.037-17.467-4.182-23.047-3.475l-0.343 5e-3c-2.039 0.284-4.256 0.719-6.791 1.334l-0.339 0.075c-3.723 0.82-7.575 1.669-11.148 1.669h-16.426c-1.3148-0.019-2.6083 0.332-3.7328 1.014l-0.0172-0.031v5.123c0.1017 2.928 0.643 5.823 1.6057 8.59zm61.398-17.7c-6.064-2.891-11.52-4.241-17.1-4.241-2.47 0.027-4.935 0.224-7.377 0.588l-0.099 0.012h-0.3c-2.175 0.296-4.601 0.812-6.891 1.313-4.03 0.92-7.638 1.684-10.987 1.684h-4.015l-0.375-0.942-1.125-2.808h-14.735v6.732c1.1711-0.558 2.453-0.843 3.75-0.836h16.425c3.411 0 7.18-0.83 10.825-1.633l0.324-0.072c2.301-0.571 4.629-1.026 6.975-1.364l0.355-7e-3c2.33-0.338 4.68-0.525 7.034-0.558 4.491 0 9.885 0.861 16.792 4.158l0.525-1.125z",
    fill: "#000000"
  }))))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath18197)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(676.5,341.25)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(.98969)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath18207)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m6.384 54.361v-36.761h15l2.25 2.25 2.25-2.25 2.25 2.25 2.25-2.25 2.25 2.25 2.25-2.25 2.25 2.25 2.25-2.25 2.25 2.25 2.25-2.25 2.25 2.25 2.25-2.25 2.25 2.25 2.25-2.25 2.25 2.25 2.25-2.25h9v7.5s-0.15 11.254-10.5 11.254h-3s-13.425 0.075-16.95 10.95c-0.014 0.037-0.034 0.109-0.058 0.201-0.164 0.644-0.245 1.306-0.242 1.971v4.885c-2e-3 0.827-0.673 1.497-1.5 1.5h-26.25c-0.8271-3e-3 -1.4971-0.672-1.5-1.5zm1.5-15.768c1.716-0.136 6.336-0.801 9.647-4.05 2.414-2.49 3.69-5.919 3.825-10.177h-13.472zm57-16.491v-3h-6.876l-1.811 1.812-1.063 1.059-1.061-1.061-1.189-1.19-1.189 1.19-1.061 1.061-1.061-1.061-1.189-1.19-1.19 1.19-1.06 1.061-1.061-1.061-1.189-1.19-1.19 1.19-1.06 1.061-1.061-1.061-1.189-1.19-1.19 1.19-1.06 1.061-1.061-1.061-1.189-1.19-1.189 1.19-1.061 1.061-1.061-1.061-1.189-1.19-1.19 1.19-1.06 1.061-1.061-1.061-1.189-1.19-1.19 1.19-1.06 1.061-1.061-1.061-1.811-1.812h-12.878v3.766h57zm-9.75 12.754h0.75c8.722 0 8.993-9.375 9-9.754v-0.736h-9.75zm-20.709 12.279c0.031-0.118 0.061-0.218 0.084-0.289 3.815-11.775 17.775-11.987 18.375-11.99h0.75v-10.49h-30.778c-0.139 4.664-1.556 8.445-4.261 11.234-3.769 3.698-8.8855 4.376-10.711 4.5v9.016h26.273c0.019-0.668 0.108-1.332 0.268-1.981zm-0.291 7.226v-3.745h-26.25v3.745z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m34.015 37.39c0.049-0.032 0.099-0.062 0.15-0.09 0.547-0.315 1.234-0.241 1.702 0.182 0.492 0.421 0.654 1.111 0.401 1.707-0.098 0.226-0.251 0.424-0.444 0.578-0.074 0.06-0.154 0.113-0.239 0.158-0.098 0.053-0.202 0.095-0.31 0.124-0.127 0.037-0.258 0.056-0.391 0.058-0.603-2e-3 -1.147-0.363-1.382-0.918-0.078-0.184-0.118-0.382-0.118-0.582 2e-3 -0.484 0.237-0.937 0.631-1.217z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m39.384 33.355c0.828 0 1.501 0.671 1.501 1.499 1e-3 0.829-0.67 1.501-1.498 1.501-0.829 1e-3 -1.501-0.67-1.502-1.498 0-0.299 0.089-0.591 0.255-0.839 0.279-0.414 0.745-0.662 1.244-0.663z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m44.053 31.223c0.373-0.158 0.794-0.158 1.166 0 0.553 0.237 0.912 0.78 0.915 1.382 0 0.2-0.04 0.398-0.119 0.582-6e-3 0.015-0.015 0.027-0.022 0.042-0.351 0.751-1.243 1.075-1.994 0.725-0.524-0.245-0.861-0.77-0.865-1.349 0-0.2 0.04-0.398 0.118-0.582 0.154-0.36 0.441-0.647 0.801-0.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m31.303 41.726c0.372-0.158 0.793-0.158 1.165 0 0.36 0.153 0.646 0.44 0.799 0.8 0.078 0.184 0.118 0.382 0.117 0.582 0 0.397-0.158 0.779-0.44 1.059-0.137 0.137-0.299 0.247-0.477 0.323-0.373 0.158-0.793 0.158-1.166 0-0.178-0.076-0.339-0.186-0.476-0.323-0.433-0.429-0.561-1.08-0.323-1.641 0.154-0.36 0.441-0.647 0.801-0.8z"
  }))))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath18225)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(797.25,335.25)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(.98969)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath18235)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m23.259 61.866c-6.075 0-10.875-4.2-10.875-9.525v-23.1c0-1.05 0.825-1.875 1.875-1.875h0.3 0.375v-8.25c0-4.575 3.675-8.25 8.25-8.25h0.3c4.575 0 8.25 3.675 8.25 8.25v8.25h0.375 0.3c1.05 0 1.875 0.825 1.875 1.875v23.1c-0.15 5.325-4.95 9.525-11.025 9.525zm-0.15-49.5c-3.75 0-6.75 3-6.75 6.75v9.75 0.075c0.825 3.825 4.575 6.15 8.4 5.325 2.7-0.6 4.725-2.7 5.325-5.325v-0.075-9.75c0-3.75-3-6.75-6.75-6.75zm9.525 39.675v-22.725c0-0.225-0.15-0.375-0.375-0.375h-0.3c-0.225 0-0.375 0.15-0.375 0.375-1.05 4.575-5.55 7.5-10.2 6.45-3.225-0.75-5.775-3.225-6.45-6.45 0-0.225-0.225-0.3-0.375-0.375h-0.3c-0.225 0-0.375 0.15-0.375 0.375v23.025c0 4.425 4.2 8.025 9.375 8.025s9.375-3.6 9.375-8.025z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m49.509 61.866c-6.075 0-10.875-4.2-10.875-9.525v-23.1c0-1.05 0.825-1.875 1.875-1.875h0.3 0.375v-8.25c0-4.575 3.675-8.25 8.25-8.25h0.225c4.575 0 8.25 3.675 8.25 8.25v8.25h0.375 0.3c1.05 0 1.875 0.825 1.875 1.875v23.1c-0.075 5.325-4.95 9.525-10.95 9.525zm0.075-49.5h-0.225c-3.75 0-6.75 3-6.75 6.75v9.75 0.075c0.825 3.825 4.575 6.15 8.4 5.325 2.7-0.6 4.725-2.7 5.325-5.325v-0.075-9.75c0-3.75-3-6.75-6.75-6.75zm9.3 39.675v-22.725c0-0.225-0.15-0.375-0.375-0.375h-0.3c-0.225 0-0.375 0.15-0.375 0.375-1.05 4.575-5.55 7.5-10.2 6.45-3.225-0.75-5.775-3.225-6.45-6.45 0-0.225-0.225-0.3-0.375-0.375h-0.3c-0.225 0-0.375 0.15-0.375 0.375v23.025c0 4.425 4.2 8.025 9.375 8.025s9.375-3.6 9.375-8.025z"
  }))))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath18247)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.2083,0,-7.54e-7,1.2083,501.75,80.25)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(.98969)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath18257)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m52.444 45.366-12.348 12.348c-2.051 2.048-5.373 2.048-7.425 0l-12.348-12.348h-13.325l4.9788-29.867c0.296-1.811 1.864-3.138 3.699-3.133h41.416c1.835-5e-3 3.403 1.322 3.699 3.133l4.979 29.867zm-41.925-12h11.667l0.642-9h-10.809zm13.17 0h11.945v-9h-11.302zm26.139 10.5-0.642-9h-12.052v9zm-14.194-9h-12.052l-0.643 9h12.695zm0-12v-9h-10.552l-0.643 9zm1.5 0h11.194l-0.642-9h-10.552zm0 1.5v9h11.944l-0.642-9zm13.448 9h11.666l-1.5-9h-10.809zm0.107 1.5 0.643 9h12.666l-1.5-9zm-16.957 21.787c1.466 1.463 3.838 1.463 5.304 0l11.287-11.287h-27.879zm-12.296-12.787 0.642-9h-11.808l-1.5003 9zm-7.98-28.12-1.187 7.12h10.667l0.642-9h-7.902c-1.101-3e-3 -2.042 0.794-2.22 1.88zm45.856 0c-0.178-1.086-1.119-1.883-2.22-1.88h-7.903l0.643 9h10.667z",
    fill: "#000000"
  }))))), /*#__PURE__*/React.createElement("path", {
    d: "m191.63 126.01v24.36",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 8,
    strokeWidth: 5.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "m457.88 125.26v24.36",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 8,
    strokeWidth: 5.25
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath18271)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(369,217.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(.98969)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath18281)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m65.836 22.435-28.702 17.354v2.3c-0.024 1.645-1.097 3.089-2.664 3.588-2.509 0.834-4.171 3.218-4.086 5.86 0.23 3.119 2.71 5.599 5.829 5.829 3.312 0.094 6.074-2.514 6.169-5.827 1e-3 -0.057 2e-3 -0.115 2e-3 -0.173h1.5c2e-3 4.142-3.355 7.501-7.497 7.503-0.072 0-0.143-1e-3 -0.215-3e-3 -3.919-0.244-7.043-3.368-7.288-7.288-0.107-3.301 1.97-6.28 5.105-7.322 0.962-0.286 1.628-1.163 1.645-2.167v-2.3l-28.702-17.355c-2.1821-1.319-2.8815-4.158-1.5622-6.34 0.8363-1.383 2.3352-2.228 3.9517-2.228h54.126c2.55 0 4.617 2.068 4.617 4.618 0 1.616-0.845 3.114-2.228 3.951zm0.614-4.789c-0.358-1.359-1.595-2.299-3-2.28h-54.129c-1.7215 0-3.1172 1.395-3.1174 3.117-2e-4 1.091 0.5707 2.103 1.5049 2.668l28.676 17.339 28.676-17.339c1.214-0.71 1.787-2.156 1.39-3.505z",
    fill: "#000000"
  }))))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath18291)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(328.5,150.75)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(.98969)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath18301)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m68.138 42.016-10.558 17.596c-0.298 0.499-0.779 0.862-1.341 1.013l-9.525 2.58-3.348 3.161c-0.405 0.382-0.901 0.653-1.441 0.788l-1.225 0.306c-2.84 0.71-5.81 0.71-8.65 0l-1.224-0.306c-0.539-0.135-1.035-0.406-1.44-0.788l-3.352-3.161-9.525-2.58c-0.562-0.15-1.042-0.514-1.34-1.014l-10.554-17.595c-0.4205-0.706-0.1979-1.618 0.5003-2.05l8.475-5.214c0.706-0.434 1.63-0.214 2.063 0.492 3e-3 5e-3 6e-3 9e-3 9e-3 0.014l3.451 5.758c2e-3 3e-3 7e-3 4e-3 0.01 1e-3 2e-3 -1e-3 3e-3 -3e-3 3e-3 -6e-3v-36.56h34.5v36.56c0 4e-3 2e-3 8e-3 6e-3 9e-3s7e-3 -1e-3 9e-3 -5e-3l3.45-5.757c0.426-0.71 1.348-0.94 2.058-0.513l0.015 9e-3 8.475 5.213c0.697 0.433 0.919 1.345 0.499 2.05zm-22.235 19.734-5.619-8.742-3.008 6.018 5.267 5.925zm-13.49 4.256c2.602 0.646 5.323 0.646 7.926 0l0.926-0.232-4.889-5.5-4.89 5.5zm-2.202-1.05 5.267-5.925-3.009-6.023-5.621 8.742zm-10.284-18.39c-0.404 0.064-0.793-0.179-0.912-0.57l-0.6-3.233-4.041-6.733-8.4738 5.211 10.559 17.599c0.099 0.166 0.259 0.288 0.446 0.338l8.359 2.264 6.656-10.354c0.138-0.214 0.376-0.344 0.631-0.345h0.039c0.27 0.015 0.511 0.173 0.631 0.414l2.405 4.809v-50.016h-15v39.8c2e-3 0.408-0.296 0.756-0.699 0.816zm38.451-10.536-4.04 6.733-0.579 3.145-0.022 0.088c-0.135 0.435-0.598 0.677-1.033 0.542-0.344-0.108-0.579-0.427-0.579-0.788v-39.8h-15v50.016l2.409-4.809c0.121-0.241 0.361-0.399 0.631-0.413h0.04c0.255 0 0.493 0.13 0.631 0.345l6.655 10.354 8.355-2.266c0.189-0.05 0.35-0.171 0.45-0.338l10.555-17.599z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m42.376 45.493h6.75v-1.5h-6.75z"
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg29);
export default __webpack_public_path__ + "static/media/29.1df90e08d46d03087cb8ef89eca00ebc.svg";
export { ForwardRef as ReactComponent };